<template lang="pug">
.componente-camadas-base__container(
    :class='{ expandido: visivel }',
    @click.stop='skip'
)
    section.componente-camadas-base__main(v-if='visivel')
        ul.componente-camadas-base__lista-camadas
            li(
                v-for='(config, index) in configCamadas',
                @click='ativarCamada(index)',
                :class='{ ativo: index === indexLayerAtiva }'
            )
                span.componente-camadas-base__label {{ config.nome }}
                img(:src='getImgUrl(config.urlImagem)', alt='basemap')

    button.componente-camadas-base__botao-controle(@click='toggle')
        i.mdi.mdi-satellite
        span {{ $t('mensagens.menuMapa.observacoes.mapasDeFundo') }}
</template>

<script>
import L from 'leaflet';
import { DEFAULT_CONFIG } from '@/utils/mapa/mapa.config';

export default {
    props: {
        mapa: {
            type: Object,
            required: true
        },
        configCamadas: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            visivel: false,
            indexLayerAtiva: -1,
            layerAtiva: null
        };
    },
    methods: {
        toggle() {
            this.visivel = !this.visivel;
        },
        ativarCamada(indexSelecionado) {
            if (indexSelecionado === this.indexLayerAtiva) return;

            if (this.layerAtiva) {
                this.mapa.removeLayer(this.layerAtiva);
            }
            this.indexLayerAtiva = indexSelecionado;
            this.layerAtiva = this.layers[this.indexLayerAtiva];

            this.mapa.addLayer(this.layerAtiva);
        },
        getImgUrl(pic) {
            // eslint-disable-next-line
            return require(`../../../assets/${pic}`);
        },
        skip() {}
    },
    mounted() {
        this.layers = this.configCamadas.map(config =>
            L.tileLayer(config.url, {
                attribution: config.attribution,
                maxZoom: DEFAULT_CONFIG.maxZoom,
                maxNativeZoom: config.maxNativeZoom
            })
        );

        this.ativarCamada(0);
    }
};
</script>

<style lang="scss">
.leaflet-control-camadas-base {
    box-shadow: none !important;
    border: none !important;
}

.componente-camadas-base__botao-controle {
    cursor: pointer;
    width: 140px !important;
    i {
        font-size: 20px;
        line-height: 30px;
        left: -2px;
        position: relative;
    }
    span {
        position: relative;
        top: -3px;
    }
}

.componente-camadas-base__container {
    &.expandido {
        width: 210px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;

        .componente-camadas-base__botao-controle {
            width: 32px !important;
            i {
                color: #0a9a84;
            }
        }
    }
}

.componente-camadas-base__main {
    background-color: var(--white);
    padding: 6px;
    border-radius: 4px;
    width: 100%;
    margin-right: 5px !important;
}

.componente-camadas-base__lista-camadas {
    list-style: none;
    padding-inline-start: 0px;
    margin: 0;
    padding: 0;
    li {
        &:first-child {
            margin-bottom: 4px;
        }
        &.ativo {
            img {
                border: 2px solid #0a9a84;
            }
            .componente-camadas-base__label {
                background-color: #0a9a84;
                color: var(--white);
            }
        }
        img {
            width: 165px;
            height: 45px;
            box-sizing: border-box;
            cursor: pointer;
            border-radius: 4px;
        }
        .componente-camadas-base__label {
            position: absolute;
            background-color: var(--white);
            border-bottom-right-radius: 4px;
            padding: 2px 4px;
            font-size: 12px;
            font-family: 'Roboto', sans-serif;
            color: #404040;
        }
    }
}
</style>
